(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./eventGetters", "../setting"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./eventGetters"), require("../setting"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.eventGetters, global.setting);
    global.eventCheckers = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _eventGetters, _setting) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hasEventCustomBraindateName = hasEventCustomBraindateName;
  _exports.isEventContextCompanies = isEventContextCompanies;
  _exports.isEventContextHybrid = isEventContextHybrid;
  _exports.isEventContextOnSite = isEventContextOnSite;
  _exports.isEventContextVirtual = isEventContextVirtual;
  _exports.isEventOccurenceLimited = isEventOccurenceLimited;
  _exports.isEventOccurrenceOngoing = isEventOccurrenceOngoing;

  /**
   * Check if an event has a custom braindate name
   * @param   {BraindateEvent} event - Event to check
   * @param   {string} [locale] - Locale in which to check
   * @returns {boolean} True if it is
   */
  function hasEventCustomBraindateName(event, locale) {
    return "braindate" in ((0, _eventGetters.getEventCustomCopy)(event, locale) || {});
  }

  /**
   * Check if an event is a hybrid context
   * @param   {BraindateEvent} event - Event to check
   * @returns {boolean} True if it is
   */
  function isEventContextHybrid(event) {
    var context = (0, _eventGetters.getEventContext)(event);
    return context === _setting.eventContextHybrid;
  }

  /**
   * Check if an event is a on-site context
   * @param   {BraindateEvent} event - Event to check
   * @returns {boolean} True if it is
   */
  function isEventContextOnSite(event) {
    var context = (0, _eventGetters.getEventContext)(event);
    return context === _setting.eventContextOnSite;
  }

  /**
   * Check if an event is a companie context
   * @param   {BraindateEvent} event - Event to check
   * @returns {boolean} True if it is
   */
  function isEventContextCompanies(event) {
    var context = (0, _eventGetters.getEventContext)(event);
    return context === _setting.eventContextCompanies;
  }

  /**
   * Check if an event is a virtual context
   * @param   {BraindateEvent} event - Event to check
   * @returns {boolean} True if it is
   */
  function isEventContextVirtual(event) {
    var context = (0, _eventGetters.getEventContext)(event);
    return context === _setting.eventContextVirtual;
  }

  /**
   * Check if an event is a limited event
   * @param   {BraindateEvent} event - Event to check
   * @returns {boolean} True if it is
   */
  function isEventOccurenceLimited(event) {
    var occurrence = (0, _eventGetters.getEventOccurrence)(event);
    return occurrence === _setting.eventOccurenceLimited;
  }

  /**
   * Check if an event is an ongoing event
   * @param   {BraindateEvent} event - Event to check
   * @returns {boolean} True if it is
   */
  function isEventOccurrenceOngoing(event) {
    var occurrence = (0, _eventGetters.getEventOccurrence)(event);
    return occurrence === _setting.eventOccurenceOngoing;
  }
});